import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { I_carouse_slide } from "./carousel.types";

/**
 * 🆂🆃🅾🆁🅴 [Carousel store]
 */
export const useCarousel = defineStore("Carousel", () => {
    const data = ref<I_carouse_slide[]>(null);
    const visible = ref<boolean>(false);

    const isShown = computed(() => visible.value);
    const slides = computed(() => data.value);

    const show = () => {
        visible.value = true;
    };

    const hide = () => {
        data.value = null;
        visible.value = false;
    };

    const setSlides = (slides: I_carouse_slide[]) => {
        data.value = slides;
    };

    return {
        isShown,
        slides,

        show,
        hide,
        setSlides,
    };
});
